import utils from "../../../utils/utils.js";

export default {
    async fetchDeckList(context) {
        const response = await utils.utility.fetch("api/editor/getsniffdeck", "GET", null, null);

        for (let deck of response.data) {
            const filterObject = JSON.parse(deck.filter);

            if (filterObject.TrendTopicLocationId && filterObject.TrendTopicLocationId != 0) {
                await context.dispatch("twitter/fetchTrendTweets", { locationId: filterObject.TrendTopicLocationId }, { root: true });

                const trendTopics = context.rootGetters["twitter/trendTweets"];

                if (trendTopics && trendTopics.length > 0) {
                    const indexOfDeck = response.data.indexOf(deck);

                    deck = { ...deck, trendTopics: trendTopics };

                    response.data[indexOfDeck] = deck;
                }
            }
        }
        
        context.commit("setDeckList", response.data);
    },
    async fetchSingleDeckList(context, payload) {
        const response = await utils.utility.fetch(`api/editor/getsinglesniffdeck?id=${payload.id}&page=${payload.page}`, "GET", null, null);

        if (payload.page > 1) {
            context.commit("pushSingleDeckList", response.data);
        } else {
            context.commit("setSingleDeckList", response.data);
        }
    },
    async postNewDeck(context, payload)  {
        const response = await utils.utility.fetch("api/editor/postsniffdeck", "POST", null, payload);

        const filterObject = JSON.parse(response.data.filter);
        
        if (filterObject.TrendTopicLocationId && filterObject.TrendTopicLocationId != 0) {
            await context.dispatch("twitter/fetchTrendTweets", { locationId: filterObject.TrendTopicLocationId }, { root: true });

            const trendTopics = context.rootGetters["twitter/trendTweets"];

            if (trendTopics && trendTopics.length > 0) {
                response.data = { ...response.data, trendTopics: trendTopics };
            }
        }

        context.commit("setNewDeck", response.data);
    },
    async fetchMentionSuggestions(context, payload) {
        var filterString = JSON.stringify(payload);
        
        const response = await utils.utility.fetch(`api/editor/getmentionsuggestions?filter=${filterString}`, "GET", null, null, true);

        context.commit("setMentionSuggestions", response.data);
    },
    async putDeckPosition(_, payload) {
        await utils.utility.fetch("api/editor/putdeckposition", "PUT", null, payload, true);
    },
    async putDeckFilter(context, payload) {
        const response = await utils.utility.fetch("api/editor/putdeckfilter", "PUT", null, payload);

        context.commit("setSingleDeckList", response.data);
    },
    async deleteDeck(context, payload) {
        const response = await utils.utility.fetch(`api/editor/deletedeck?id=${payload.id}`, "PUT", null, null);

        context.commit("deleteDeck", response.data);
    },
    async fetchDeckFeedAnswers(context, payload) {
        const response = await utils.utility.fetch(`api/Editor/GetDeckFeedAnswers?id=${payload.feedId}&includeDialogueCandidates=true`, "GET", null, null);
        
        context.commit("setDeckFeedAnswers", { answers: [...response.data], deckId: payload.deckId, feedId: payload.feedId });
    },
    showFeedAnswers(context, payload) {
        context.commit("showFeedAnswers", payload);
    },
    hideFeedAnswers(context, payload) {
        context.commit("hideFeedAnswers", payload);
    },
    async putFeedSentiment(context, payload) {
        await utils.utility.fetch("api/editor/changesentiment", "PUT", null, { feedId: payload.feedId, sentimentId: payload.sentimentId });
                
        context.commit("setSentiment", payload);
    },
    async fetchUserFeedHistory(context, payload) {
        const response = await utils.utility.fetch(`api/Editor/GetUserFeedHistory?feedId=${payload.feedId}`, "GET", null, null);

        context.commit("setUserFeedHistory", response.data.feedList);
    },
    async fetchUserFeedHistoryAnswers(context, payload) {
        const response = await utils.utility.fetch(`api/Editor/GetDeckFeedAnswers?id=${payload.feedId}&includeDialogueCandidates=true`, "GET", null, null);

        context.commit("setUserFeedHistoryAnswers", { answers: [...response.data], feedId: payload.feedId });
    },
    async fetchDialogueCandidates(_, payload) {
        const sourceIds = Array.isArray(payload?.Ids) ? payload.Ids : payload?.ids;

        const ids = Array.isArray(sourceIds)
            ? [...new Set(sourceIds.map(x => Number(x)).filter(x => !Number.isNaN(x) && x > 0))]
            : [];

        const parseResponse = (response) => {
            if (Array.isArray(response)) {
                return response;
            }

            if (Array.isArray(response?.data)) {
                return response.data;
            }

            return [];
        };

        if (ids.length == 0) {
            return [];
        }

        const responses = await Promise.all(ids.map(async (docId) => {
            const response = await utils.utility.fetch(`api/Editor/GetDeckFeedAnswers?id=${docId}&includeDialogueCandidates=true`, "GET", null, null);
            const items = parseResponse(response);

            return items.map(item => ({
                ...item,
                docId: item.docId ?? docId
            }));
        }));

        return responses.flat();
    },
    async postAqosData(_, payload) {
        await utils.utility.fetch("api/editor/DialoguePost", "POST", null, payload);
    }
}